import { render, staticRenderFns } from "./ThgMyVehicleRenewalOptionsSheet.vue?vue&type=template&id=0a4bfdcd&scoped=true"
import script from "./ThgMyVehicleRenewalOptionsSheet.vue?vue&type=script&lang=ts"
export * from "./ThgMyVehicleRenewalOptionsSheet.vue?vue&type=script&lang=ts"
import style0 from "./ThgMyVehicleRenewalOptionsSheet.vue?vue&type=style&index=0&id=0a4bfdcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bfdcd",
  null
  
)

export default component.exports